/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import axios from 'axios'

export const TokenExportService = {
    async generateToken(company) {
        return axios.post(`/api/${company}/tokens`)
    },
    async list(company) {
        return axios.get(`/api/${company}/tokens`)
    }
}
